// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import WarningRoundSvg from '../icons/status/WarningRound';
var WarningRound = createSvgIcon({
    as: WarningRoundSvg,
    ariaLabel: 'warning round',
    category: 'status',
    displayName: 'WarningRound'
});
export default WarningRound;
